export default __webpack_public_path__ + "static/media/card3-ecom.aef656a9.jpg";